/**
 * מצב תשלום צ'אט — מקור אמת יחיד לתצוגת סכום (LockedPaymentOffer).
 * מודול סינכרוני + useSyncExternalStore מהרכיבים.
 */

/** @typedef {{
 *   offerId: string|null,
 *   chatSessionId: string|null,
 *   agentId: string|null,
 *   approvedPriceIls: number,
 *   paymentPriceIls: number,
 *   currency: string,
 *   passengersHash: string,
 *   tripHash: string,
 *   createdAt: number,
 *   source: string,
 * }} LockedPaymentOffer */

let lockedOffer = /** @type {LockedPaymentOffer|null} */ (null);
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* ignore */
    }
  });
}

export function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getChatPaymentLockSnapshot() {
  return lockedOffer;
}

/**
 * עותק לשימוש ב־API (לא מחזירים את האובייקט הפנימי).
 * @returns {LockedPaymentOffer|null}
 */
export function peekChatPaymentLockForApi() {
  return lockedOffer ? { ...lockedOffer } : null;
}

/**
 * @param {LockedPaymentOffer} offer
 */
export function setChatPaymentLockedOffer(offer) {
  lockedOffer = offer;
  emit();
}

export function clearChatPaymentLock() {
  lockedOffer = null;
  emit();
}

/**
 * After order load / server PRICE_REFRESH — align lock with order canonical ILS (single charge amount).
 * @param {number} ilsRounded
 * @returns {boolean}
 */
export function reconcileChatPaymentLockToOrderCanonical(ilsRounded) {
  if (lockedOffer == null) return false;
  const v = Math.round(Number(ilsRounded));
  if (!Number.isFinite(v) || v <= 0) return false;
  lockedOffer = {
    ...lockedOffer,
    approvedPriceIls: v,
    paymentPriceIls: v,
  };
  emit();
  return true;
}
